import { useContext } from "react"
import { Button } from "@headlessui/react"
import { PauseIcon, PlayIcon, PlayPauseIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function PlayPause() {
  const { pauseAll, playAll, playPause } = useContext(MultiContext)
  const onClick = ({ uuid }) => playPause(uuid)

  return (
    <Panel>
      <Panel.Buttons>
        <Button
          onClick={playAll}
          className="flex h-fit items-center gap-2 rounded-lg bg-gray-900/10 px-4 py-2 text-sm text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
        >
          <PlayIcon aria-hidden="true" className="-ml-0.5 size-5" />
          Play all
        </Button>
        <Button
          onClick={pauseAll}
          className="flex h-fit items-center gap-2 rounded-lg bg-gray-900/10 px-4 py-2 text-sm text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
        >
          <PauseIcon aria-hidden="true" className="-ml-0.5 size-5" />
          Pause all
        </Button>
      </Panel.Buttons>
      <Panel.Layout Icon={PlayPauseIcon} onClick={onClick} />
    </Panel>
  )
}
